<template>
  <div class="container-fluid py-3 px-2 px-md-4">
    <div class="row align-items-center mb-2">
      <div class="col-8 mt-1 d-flex align-items-center">
        <button class="btn btn-danger ms-2" @click="$router.push(`/SeguimientoSolicitud`)">
          <i class="bi bi-skip-backward"></i>
        </button>
      </div>
      <div class="col-4 mt-1 d-flex justify-content-end align-items-center">

        <label v-if="campaña" class="tituloColorMas text-danger me-2" style="font-size:1.73rem">
          <i class="bi bi-rocket-takeoff"></i> CAMPAÑA
        </label>

        <label class="letrasTitulos fw-bold me-1" style="font-size:1.73rem">
          N°
        </label>

        <label class="letrasTitulos ms-1 me-4" style="font-size:1.73rem">
          <strong>{{ IdSolicitud }}</strong>
        </label>
      </div>
    </div>

    <!-- PANEL PRINCIPAL -->
    <div class="mx-2">
      <div class="col-12">
        <div class="border border-1 rounded-3 px-3 py-2 mb-2 bg-white shadow-sm 
              d-flex justify-content-between align-items-center flex-wrap">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-journal-text display-5 text-primary"></i>
            <div class="lh-sm">
              <p class="mb-1 reducirTamaño text-secondary fw-semibold text-uppercase">
                SEGUIMIENTO DE SOLICITUDES
              </p>
              <p class="mb-0 tituloResaltado fs-5 fw-bold">DATOS DE LA SOLICITUD</p>
            </div>
          </div>
          <div class="text-end my-auto">
            <i class="bi bi-chevron-down fs-5" @click="ocultar = !ocultar"></i>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div v-if="ocultar" class="tamaño row g-2 mb-2">

          <!-- TARJETA 1 -->
          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100"
              style="font-size: 1.50rem; font-weight: 700">
              <label class="ms-2 letrasTitulos fw-bold">
                <strong>{{ CanPostulante }}</strong> {{ NomPuesto }}
              </label>
            </div>
          </div>

          <!-- TARJETA 2 -->
          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100"
              style="font-size: 1.50rem; font-weight: 700">
              <label class="ms-2 letrasTitulos fw-bold">
                {{ DesDepartamento }} - {{ DesProvincia }} - {{ DesDistrito }}
              </label>
            </div>
          </div>

          <!-- TARJETA 3 -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 text-end">

              <div>
                <label class="text-danger fw-bold" :class="{ 'text-danger': FecPresentacion.slice(7, 11) == '1900' }">
                  DEADLINE:
                </label>

                <label class="fw-bold" v-if="FecPresentacion.slice(7, 11) != '1900'">
                  {{ FecPresentacion }}
                </label>

                <label class="fw-bold text-danger" v-else> - </label>
              </div>

              <div class="text-dark">
                <label class="fw-bold">{{ nomSelAsignado }}</label>
              </div>

              <div>
                <label class="fw-bold text-primary">{{ desSolEstado }}</label>
              </div>
            </div>
          </div>
      <div class="col-12">
        <div class="row g-2">
          <p class="mb-0 tamaño">
            REQUERIMIENTO SOLICITADO EL <strong>{{ FecRegistro }}</strong> — FECHA ESTIMADA ENTREGA:
            <strong>{{ FecFinEstimada }}</strong>
          </p>

          <!-- SERVICIO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">SERVICIO:</p>
              <label class="tamaño">
                {{
                  idEmpresaRq == 1
                    ? 'SELECCION'
                    : [2, 3].includes(idEmpresaRq)
                      ? 'OUTSOURCING'
                      : 'INTERMEDIACIÓN'
                }}
              </label>
            </div>
          </div>

          <!-- PROYECTO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">PROYECTO:</p>
              <label class="tamaño">{{ SubCentroCosto }} | {{ SubSubCentroCosto }}</label>
            </div>
          </div>

          <!-- SOLICITANTE -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">SOLICITANTE:</p>
              <label class="tamaño">{{ NomTrabajador }}</label>
            </div>
          </div>

          <!-- MOTIVO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">MOTIVO:</p>
              <label class="tamaño">{{ DesMotivo }}</label>
            </div>
          </div>

          <!-- LUGAR DE TRABAJO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">LUGAR DE TRABAJO:</p>
              <label class="tamaño">{{ LugarTrabajo }}</label>
            </div>
          </div>

          <!-- HORARIO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">HORARIO DE TRABAJO:</p>
              <label class="tamaño">{{ HorTrabajo }}</label>
            </div>
          </div>

          <!-- TIPO DE CONTRATO -->
          <!-- <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 pintar">T. CONTRATO:</p>
              <label class="tamaño">{{ DesTipContrato }}</label>
            </div>
          </div> -->

          <!-- DETALLE -->
          <div class="col-12">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm">
              <p class="mb-0 pintar">DETALLE:</p>
              <label class="tamaño">{{ DesExtra }}</label>
            </div>
          </div>


          <div class="col-12" v-if="
            permisoVisualizador == 2 ||
            permisoVisualizador == 6 ||
            (permisoVisualizador == 8 && codigoCentro != '02' ) ||
            (permisoVisualizador == 18 && codigoCentro != '02')
          ">
            <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

              <div class="d-flex flex-wrap justify-content-around text-center">

                <div class="mx-3">
                  <i class="bi bi-calendar3 fs-4"></i>
                  <p class="color mb-0">{{ DesOpoPago }}</p>
                  <p class="tamaño mb-0">Oportunidad de Pago</p>
                </div>

                <div v-if="SueldoMensual > 0" class="mx-3">
                  <i class="bi bi-cash-stack fs-4"></i>
                  <p class="color mb-0">{{ SueldoMensual }}</p>
                  <p class="tamaño mb-0">Sueldo básico (RBM)</p>
                </div>

                <div v-if="SueldoDiario > 0" class="mx-3">
                  <i class="bi bi-coin fs-4"></i>
                  <p class="color mb-0">{{ SueldoDiario }}</p>
                  <p class="tamaño mb-0">Sueldo básico (RBD)</p>
                </div>

                <div v-if="MonAlimientacion > 0" class="mx-3">
                  <i class="bi bi-cup-hot fs-4"></i>
                  <p class="color mb-0">{{ MonAlimientacion }}</p>
                  <p class="tamaño mb-0">Alimentación</p>
                </div>

                <div v-if="MonMovilidad > 0" class="mx-3">
                  <i class="bi bi-car-front-fill fs-4"></i>
                  <p class="color mb-0">{{ MonMovilidad }}</p>
                  <p class="tamaño mb-0">Movilidad</p>
                </div>

                <div v-if="MonVariable > 0" class="mx-3">
                  <i class="bi bi-wallet2 fs-4"></i>
                  <p class="color mb-0">{{ MonVariable }}</p>
                  <p class="tamaño mb-0">Variable</p>
                </div>

                <div v-if="MonViatico > 0" class="mx-3">
                  <i class="bi bi-luggage fs-4"></i>
                  <p class="color mb-0">{{ MonViatico }}</p>
                  <p class="tamaño mb-0">Viáticos</p>
                </div>

                <div v-if="HoraExtra > 0" class="mx-3">
                  <i class="bi bi-hourglass-top fs-4"></i>
                  <p class="color mb-0">{{ HoraExtra }}</p>
                  <p class="tamaño mb-0">Horas Extra</p>
                </div>

                <div v-if="DiasDescanso > 0" class="mx-3">
                  <i class="bi bi-calendar-event fs-4"></i>
                  <p class="color mb-0">{{ DiasDescanso }}</p>
                  <p class="tamaño mb-0">Descanso (Días)</p>
                </div>

                <div v-if="MonOtro > 0" class="mx-3">
                  <i class="bi bi-file-plus fs-4"></i>
                  <p class="color mb-0">{{ MonOtro }}</p>
                  <p class="tamaño mb-0">Otros</p>
                </div>

              </div>
            </div>
          </div>

          <!-- DOCUMENTACIÓN -->
          <div v-if="
                IndVacuna ||
                IndCarnet ||
                IndVulnerabilidad ||
                indJudiciales ||
                indPoliciales ||
                indPenales ||
                indSanidad ||
                indCertijoven
              " class="col-12 col-md-3 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- ICONO IZQUIERDA -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-check fs-2 text-success"></i>
                  </div>

                  <!-- CHECKBOXES DERECHA -->
                  <div class="flex-grow-1">
                    <div v-if="IndVacuna" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndVacuna" />
                      <label class="form-check-label">CARNET DE VACUNACION</label>
                    </div>

                    <div v-if="IndCarnet" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndCarnet" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="IndVulnerabilidad" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="IndVulnerabilidad" />
                      <label class="form-check-label">DECLARACION JURADA DE VULNERABILIDAD</label>
                    </div>

                    <div v-if="indJudiciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indJudiciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES JUDICIALES</label>
                    </div>

                    <div v-if="indPoliciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPoliciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES POLICIALES</label>
                    </div>

                    <div v-if="indPenales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPenales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES PENALES</label>
                    </div>

                    <div v-if="indSanidad" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indSanidad" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="indCertijoven" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="indCertijoven" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES O CERTIJOVEN</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="IndEmpo || IndCovid" class="col-12 col-md-3 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <div class="mx-3 text-center my-auto">
                    <i class="bi bi-clipboard-heart fs-2 text-danger"></i>
                  </div>
                  <div class="">
                    <div v-if="IndEmpo" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndEmpo" />
                      <label class="form-check-label" for="flexCheckDefault">
                        EXAMEN MEDICO PRE-OCUPACIONAL(EMPO)
                      </label>
                    </div>
                    <div v-if="IndCovid" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndCovid" />
                      <label class="form-check-label" for="flexCheckDefault">
                        PRUEBA COVID
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- Icono centrado -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-data fs-2 text-primary"></i>
                  </div>

                  <!-- Opciones compactas -->
                  <div class="d-flex flex-wrap flex-grow-1">
                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solDisViaje" />
                      <label class="form-check-label">DISPONIBILIDAD DE VIAJE</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovPropio" />
                      <label class="form-check-label">USO DE MOVIL PROPIO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solAplicativo" />
                      <label class="form-check-label">USO DE APLICATIVOS</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solEpps" />
                      <label class="form-check-label">USO DE EPPs</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solUniforme" />
                      <label class="form-check-label">USO DE UNIFORME</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovil" />
                      <label class="form-check-label">USO DE MOVIL CORPORATIVO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solLaptop" />
                      <label class="form-check-label">USO DE LAPTOP CORPORATIVA</label>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
                  <button class="btn btn-primary text-white boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </button>
                  <p class="mt-2 text-center mb-0 align-self-center">FORMATO DE PERFIL DEL PUESTO </p>
                  <a v-if="rutaPerfil != '0'" :href="url.slice(0, 49) + rutaPerfil.slice(42)" target="_blank">
                  </a>
                </div>
              </div>

          <!-- ADJUNTO -->
          <div class="col-12 col-md-4 tamaño" v-if="Adjunto != 1">
            <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
              <a :href="url + Adjunto.slice(52)" target="_blank">
                <i class="bi bi-file-earmark-arrow-down fs-2"></i>
              </a>
              <p class="mt-2">{{ Adjunto.slice(52) }}</p>
            </div>
          </div>
          </div>
        
          
        </div>
        
      </div>
      </div>
    </div>

   
<TablaSeguimientoSolicitudxSol />
  </div>


</template>

<script>
import TablaSeguimientoSolicitudxSol from "./SegTablaPostulante.vue";
export default {
  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Solicitud/",
      amigo: "",
      negado: true,
      negado2: true,
      cerrarPostulante: false,
      IdSolicitud: "",
      FecRegistro: "",
      FecFinEstimada: "",
      FecPresentacion: "",
      NomPuesto: "",
      CanPostulante: "",
      NomEmpresa: "",
      CentroCosto: "",
      SubCentroCosto: "",
      SubSubCentroCosto: "",
      DesDepartamento: "",
      DesProvincia: "",
      DesDistrito: "",
      NomTrabajador: "",
      CargoBoleta: "",
      DesMotivo: "",
      DesExtra: "",
      DetalleMotivo: "",
      LugarTrabajo: "",
      HorTrabajo: "",
      DesTipContrato: "",
      DiasDescanso: "",
      SueldoMensual: "",
      SueldoDiario: "",
      MonVariable: "",
      MonAlimientacion: "",
      MonMovilidad: "",
      HoraExtra: "",
      MonViatico: "",
      MonOtro: "",
      DesOpoPago: "",
      IndVacuna: "",
      IndCarnet: "",
      IndVulnerabilidad: "",
      IndEmpo: "",
      IndCovid: "",
      Adjunto: "",

      campaña: "",

      indJudiciales: Boolean,
      indPoliciales: Boolean,
      indPenales: Boolean,
      indSanidad: Boolean,
      indCertijoven: Boolean,

      //otra api
      info: [],
      desSolEstado: null,
      nomSelAsignado: null,
      //tercera api
      responsable: [],

      mandarPut: {
        idSolicitud: "",
        idSelAsignado: "",
      },

      codSolEstado: "",
      nombreDelUsuario: "",
      ocultar: true,
      permisoVisualizador: null,
      codigoCentro: "",
      idEmpresaRq: "",

      solDisViaje: false,
      solMovPropio: false,
      solAplicativo: false,
      solEpps: false,
      solUniforme: false,
      solMovil: false,
      solLaptop: false,
      rutaPerfil:''

    };
  },
  async mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    this.parametro = this.$route.params.id;
    console.log(this.parametro);

    const api3 = this.axios.get("JerarquiaTrabajadorData/Jerarquia/4");
    let r = await api3;
    this.responsable = r.data;
    console.log(r.data);

    const api2 = this.axios.get("ParametroData/Parametro/59");
    let res = await api2;
    this.info = res.data;

    console.log(res.data);

    this.mandarPut.idSolicitud = this.$route.params.id;

    const api = this.axios.get(
      "SolicitudData/Obtener/" + this.mandarPut.idSolicitud
    );
    let response = await api;
    console.log(response);
    this.IdSolicitud = response.data[0].idSolicitud;
    this.FecRegistro = response.data[0].fecRegistro;
    this.FecFinEstimada = response.data[0].fecSolFinal;
    this.FecPresentacion = response.data[0].fecPresentacion;
    this.NomPuesto = response.data[0].nomPuesto;
    this.CanPostulante = response.data[0].canPostulante;
    this.NomEmpresa = response.data[0].nomEmpresa;
    this.CentroCosto = response.data[0].centroCosto;
    this.SubCentroCosto = response.data[0].subCentroCosto;
    this.SubSubCentroCosto = response.data[0].subSubCentroCosto;
    this.DesDepartamento = response.data[0].desDepartamento;
    this.DesProvincia = response.data[0].desProvincia;
    this.DesDistrito = response.data[0].desDistrito;
    this.NomTrabajador = response.data[0].nomTrabajador;
    this.CargoBoleta = response.data[0].cargoBoleta;
    this.DesMotivo = response.data[0].desMotivo;
    this.DesExtra = response.data[0].desExtra;
    this.DetalleMotivo = response.data[0].detalleMotivo;
    this.LugarTrabajo = response.data[0].lugarTrabajo;
    this.HorTrabajo = response.data[0].horTrabajo;
    this.DesTipContrato = response.data[0].desTipContrato;
    this.DiasDescanso = response.data[0].diasDescanso;
    this.SueldoMensual = response.data[0].sueldoMensual;
    this.SueldoDiario = response.data[0].sueldoDiario;
    this.MonVariable = response.data[0].monVariable;
    this.MonAlimientacion = response.data[0].monAlimentacion;
    this.MonMovilidad = response.data[0].monMovilidad;
    this.HoraExtra = response.data[0].horaExtra;
    this.MonViatico = response.data[0].monViatico;
    this.MonOtro = response.data[0].monOtro;
    this.DesOpoPago = response.data[0].desOpoPago;
    this.Adjunto = response.data[0].adjunto;

    this.campaña = response.data[0].campana;

    this.desSolEstado = response.data[0].desSolEstado;
    this.nomSelAsignado = response.data[0].nomSelAsignado;

    this.IndVacuna = response.data[0].indVacuna;
    this.IndCarnet = response.data[0].indCarnet;
    this.IndVulnerabilidad = response.data[0].indVulnerabilidad;
    this.IndEmpo = response.data[0].indEmpo;
    this.IndCovid = response.data[0].indCovid;
    this.indJudiciales = response.data[0].indJudiciales;
    this.indPoliciales = response.data[0].indPoliciales;
    this.indPenales = response.data[0].indPenales;
    this.indSanidad = response.data[0].indSanidad;
    this.indCertijoven = response.data[0].indCertiJoven;
    this.codigoCentro = response.data[0].codCentro
    this.idEmpresaRq = response.data[0].idEmpresa

    this.solDisViaje = response.data[0].solDisviaje
    this.solMovPropio = response.data[0].solMovpropio
    this.solAplicativo = response.data[0].solAplicativo
    this.solEpps = response.data[0].usoSolEPPs
    this.solUniforme = response.data[0].usoSolUniforme
    this.solMovil = response.data[0].usoSolMovilCoporativo
    this.solLaptop = response.data[0].usoSolLaptop
    this.rutaPerfil  = response.data[0].rutaPerfil

    //segunda api
  },
  created() {
    this.cambiarEstadoNavbar();
  },
  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
  // SeleccionTables
  components: { TablaSeguimientoSolicitudxSol },
};
</script>
<style scoped>
.color {
  font-weight: 700;
}

input {
  font-size: 0.65rem;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 1.2rem;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamaño {
  font-size: 0.65rem;
}

.tabla {
  background: rgb(24, 147, 196);
}

.bg-solimano {
  background: #0080c8;
}

.agrandar {
  width: 280px;
  /* height: 10px; */
}

.tamañoLetra {
  font-family: sans-serif;
  font-size: 0.65rem;
}

.pintar {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamañoCuadro {
  font-size: 0.65rem;
}

.letrasTitulos {
  color: #52658c;
}

.selector {
  width: 500px;
}

#modal-center5 .modal-dialog {
  min-height: 300px;
  /* Ajusta el valor según tus necesidades */
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
</style>
